<div>
  <!-- <div class="flex p-b-40" *ngIf="showDropdown">
    <nz-select nzShowSearch  class="w-100-pc" nzPlaceHolder="Select view">
      <nz-option nzCustomContent nzValue="0"><span translate>Everything</span> </nz-option>
      <nz-option nzCustomContent nzValue="1"><span translate>Workflow Audit</span></nz-option>
      <nz-option nzCustomContent nzValue="2"><span translate>Customer Correspondence</span></nz-option>
    </nz-select>
  </div> -->
  <nz-timeline>
    <nz-timeline-item [nzColor]="item.color" *ngFor="let item of workFlowAudit">
      <ng-container *ngIf="item?.objectName == 'TaskDO'">
        <h4 class="f-w-600">{{(item.serviceTask | technicalTranslate) || '-'}} <nz-tag class="m-l-5"
            [nzColor]="item.color">{{(item.status  | technicalTranslate) || '-'}}</nz-tag>
        </h4>
        <p>
          <!-- <i class="anticon anticon-calendar"></i> -->
          <span nz-icon nzType="calendar" nzTheme="outline"></span>
          {{ commonUtilty.serverDOtoUIDODate(item.startDt) ? (commonUtilty.serverDOtoUIDODate(item.startDt) | date : appMetadataHandler.GLOBAL_DATE_FORMAT_ANGULAR) : '' }}
          <!-- <span *ngIf="item.startDt && item.endDt"> ( {{getDayDifference(item.startDt,item.endDt)}})</span> -->
        </p>
        <p>
          <span translate>Work queue:</span> {{(item.workQueue | technicalTranslate) || '-'}} <br>
          <!-- lastReassignedBy -->
          <span translate>Assignee:</span> {{(item.taskUser | technicalTranslate) || '-'}} <br>
          <span translate>Assigned By:</span> {{(item.lastReassignedBy | technicalTranslate) || '-'}} <br>
          <!-- <span translate>Priority:</span> {{(item.priority | technicalTranslate) || '-'}} <br> -->
          <span *ngIf="item.tatInMins !=null "> <span translate>Completed in:</span> {{item.tatInMins}} Minutes</span>
        </p>
      </ng-container>
      <ng-container *ngIf="item?.objectName == 'CorrespondenceDO'">
        <h4 class="f-w-600">{{item.channelCd}}
          <span *ngIf="item.statusCd === 'PENDING'">
            <nz-tag [nzColor]="'orange'">Pending</nz-tag>
          </span>
          <span *ngIf="item.statusCd === 'VERIFIED'">
            <nz-tag [nzColor]="'green'">Verified</nz-tag>
          </span>
          <span *ngIf="item.statusCd === 'DISPATCHED'">
            <nz-tag [nzColor]="'blue'">Dispatched</nz-tag>
          </span>
        </h4>
        <p><i class="anticon anticon-calendar"></i>{{getDateString(item?.createdDt)}}</p>
        <p>
          <span *ngIf="item.receipent != null"> To: {{item?.receipent}}</span> <span *ngIf="item.receipent != null">
            <br></span>
          <span *ngIf="item.templateDesc != null">
            <!-- <a (click)="fetchMessageByGuid(item)">
              Message: {{item?.templateDesc}}
            </a> -->
            Message: {{item?.templateDesc}}
          </span> <br>
          <span *ngIf="item.clientRefGuid != null"> : {{getClienNameByGuid(item?.clientRefGuid)['name']}}</span>
          <br>
        </p>
      </ng-container>
    </nz-timeline-item>
  </nz-timeline>
</div>
